import React from "react";
import { primaryOrange, netural400 } from "../../utils/colors";
import CustomLabel from "../shared/label/custom-label.component";

const PriceDisplay = ({
  // PRICE DATA
  price,
  finalTotal,
  quantity = 1,
  discount,

  // STYLES
  containerStyle = {},
  normalStyle = {},
  discountedStyle = {},
  originalPriceStyle = {},
  freeStyle = {},
  outOfStockStyle = {},

  // LABEL PROPS
  normalProps = {},
  discountedProps = {},
  originalPriceProps = {},
  freeProps = {},
  outOfStockProps = {},

  // OTHER
  currency = "$",
  showDecimals = false,
}) => {
  const parsePriceValue = (value) => {
    if (typeof value === "number") {
      return Number.isFinite(value) ? value : NaN;
    }

    if (typeof value === "string") {
      const normalizedValue = value.replace(/[^0-9.-]/g, "");
      if (
        normalizedValue === "" ||
        normalizedValue === "-" ||
        normalizedValue === "." ||
        normalizedValue === "-."
      ) {
        return NaN;
      }

      const parsedValue = Number(normalizedValue);
      return Number.isFinite(parsedValue) ? parsedValue : NaN;
    }

    return NaN;
  };

  const originalPrice = parsePriceValue(price);
  const discountedPrice = parsePriceValue(finalTotal);
  const stock = Number(quantity);
  const discountValue = Number(discount);
  const hasOriginalPrice = Number.isFinite(originalPrice);
  const hasDiscountedPrice = Number.isFinite(discountedPrice);

  const resolvedOriginalPrice = hasOriginalPrice
    ? originalPrice
    : hasDiscountedPrice
    ? discountedPrice
    : 0;
  const resolvedDiscountedPrice = hasDiscountedPrice
    ? discountedPrice
    : resolvedOriginalPrice;

  const formatPrice = (value) => {
    return showDecimals ? value.toFixed(2) : value;
  };

  // 1. OUT OF STOCK
  if (stock === 0) {
    return (
      <CustomLabel
        {...outOfStockProps}
        style={{
          color: "red",
          ...outOfStockStyle,
        }}
      >
        Out of Stock
      </CustomLabel>
    );
  }

  // 2. FREE
  if (
    (hasOriginalPrice && originalPrice === 0) ||
    (hasDiscountedPrice && discountedPrice === 0) ||
    discountValue === 100
  ) {
    return (
      <CustomLabel
        {...freeProps}
        style={{
          color: primaryOrange,
          fontWeight: "600",
          ...freeStyle,
        }}
      >
        Free
      </CustomLabel>
    );
  }

  // 3. NORMAL PRICE
  if (resolvedOriginalPrice === resolvedDiscountedPrice) {
    return (
      <CustomLabel
        {...normalProps}
        style={{
          color: netural400,
          cursor: "pointer",
          ...normalStyle,
        }}
      >
        {currency}
        {formatPrice(resolvedOriginalPrice)}
      </CustomLabel>
    );
  }

  // 4. DISCOUNTED PRICE
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        ...containerStyle,
      }}
    >
      <CustomLabel
        {...discountedProps}
        style={{
          fontWeight: "600",
          color: primaryOrange,
          marginRight: 8,
          cursor: "pointer",
          ...discountedStyle,
        }}
      >
        {currency}
        {formatPrice(resolvedDiscountedPrice)}
      </CustomLabel>

      <CustomLabel
        {...originalPriceProps}
        style={{
          textDecoration: "line-through",
          color: netural400,
          cursor: "pointer",
          ...originalPriceStyle,
        }}
      >
        {currency}
        {formatPrice(resolvedOriginalPrice)}
      </CustomLabel>
    </div>
  );
};

export default PriceDisplay;
